import React, { useState, useEffect } from 'react';
import { Clock, Filter, Download } from 'lucide-react';
import BaseLayout from '../../layouts/BaseLayout';
import ActivityFilters from './components/ActivityFilters';
import ActivityTable from './components/ActivityTable';
import { useApiHandler } from '../../utils/apiHandler';

export default function ActivityPage() {
    const [timeRange, setTimeRange] = useState('today');
    const [selectedDepartments, setSelectedDepartments] = useState([]);
    const [loginLogoutData, setLoginLogoutData] = useState({ data: [], pagination: {} }); // Updated structure
    const [currentPage, setCurrentPage] = useState(1);  // To track current page
    const apiHandler = useApiHandler();

    // Fetch login/logout data from the API
    useEffect(() => {
        const fetchLoginLogoutData = async () => {
            try {
                const response = await apiHandler.get(`/admin/loginlogoutdata?page=${currentPage}&timeRange=${timeRange}`); // Modify API call based on pagination and filters
                if (response.data.success) {
                    setLoginLogoutData(response.data.data); // Store the fetched data
                } else {
                    console.error('Failed to fetch login/logout data');
                }
            } catch (error) {
                console.error('Error fetching login/logout data:', error);
            }
        };

        fetchLoginLogoutData();
    }, [currentPage, timeRange]);  // Trigger fetch when page or time range changes

    const onPageChange = (page) => {
        if (page > 0 && page <= loginLogoutData.pagination.totalPages) {
            setCurrentPage(page);
        }
    };

    return (
        <BaseLayout>
            <div className="min-h-screen bg-slate-50">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                    {/* Page Header */}
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-8">
                        <div>
                            <h1 className="text-2xl font-semibold text-gray-900 flex items-center gap-2">
                                <Clock className="w-7 h-7 text-blue-600" />
                                Employee Activity
                            </h1>
                            <p className="mt-1 text-sm text-gray-500">
                                Track employee attendance and working hours
                            </p>
                        </div>
                        <div className="flex gap-3">
                            <button className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-lg hover:bg-gray-50">
                                <Filter className="w-4 h-4" />
                                Filters
                            </button>
                            <button className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-lg hover:bg-gray-50">
                                <Download className="w-4 h-4" />
                                Export
                            </button>
                        </div>
                    </div>

                    {/* Filters */}
                    {/* Activity Table */}
                    <ActivityTable
                        loginLogoutData={loginLogoutData} // Pass the login/logout data to the table
                        onPageChange={onPageChange} // Pass the onPageChange function to the table
                    />
                </div>
            </div>
        </BaseLayout>
    );
}
